import { AxiosService } from "./AxiosService"

type AppMetaResponse = {
    gtagID?: string
}

type PageMetaResponse = {
    title: string
    description: string
}

export const MetaService = new (class {
    getAppMeta(): Promise<AppMetaResponse> {
        return AxiosService.get(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/meta`)
    }

    getPageMeta(pageType: "dashboard" | "networkCoverage"): Promise<PageMetaResponse> {
        return AxiosService.get(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/meta/pages/${pageType}`)
    }
})()

export const AdminMetaService = new (class {
    getAppMeta(userToken: string, gtagId: string): Promise<void> {
        return AxiosService.putAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/meta`, userToken, { gtagId })
    }

    getPageMeta(userToken: string, pageType: "dashboard" | "network", title: string, description: string): Promise<void> {
        return AxiosService.putAuth(`${process.env.REACT_APP_MIDDLEWARE_ENDPOINT}/meta/pages/${pageType}`, userToken, { title, description })
    }
})()
